import Modal from '@/components/modal/Modal';
import { Col } from '@/lib/utils';
import React from 'react';
import { StageCoachReviewInfo } from '@/features/centerReview';
import ModalCoachReviewHeader from './ModalCoachReviewHeader';
import ModalCoachReviewContent from './ModalCoachReviewContent';

type Props = {
    unmount?: () => void;
    stageData: StageCoachReviewInfo;
    config: {
        key: string;
        label: string;
        badgeNumber: number;
    };
};

function ModalCoachReview({ unmount, stageData, config }: Props) {
    const handleClose = () => {
        if (unmount) unmount();
    };

    return (
        <Modal onClose={handleClose} isCloseButton borderRadius={35}>
            <Col className="py-[42px] px-[50px] w-[1000px] h-[800px]">
                {/* 헤더 */}
                <ModalCoachReviewHeader
                    badgeNumber={config.badgeNumber}
                    label={config.label}
                    stageData={stageData}
                />
                <ModalCoachReviewContent label={config.label} stageData={stageData} />
            </Col>
        </Modal>
    );
}

export default ModalCoachReview;
